var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 137 230",
    viewBox: "0 0 137 230",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f8bd7a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m922.9 113.8-2.3-.3c.2 1.2.3 2.5.5 3.8.5-1.2 1.2-2.4 1.8-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.3 119.3-42.1 106.8 117.5-146.4-51.8 1.2 43.7-72.5c0-.1 0-.1.1-.2 0-.1 0-.2.1-.3s0-.1.1-.1c.1-.2.1-.4.2-.6 0-.1.1-.3.2-.4-.1-.2 0-.4.1-.5s.2-.2.3-.2v-.1c0-.1 0-.1 0-.2s.1-.3.2-.4v-.1c0-.1.1-.1.1-.1v-.1c0-.2.1-.4.2-.6l-59.6 1.4-54 114.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.2f59f46cde5a0c4c3deb66bfc45c6045.svg";
export { ForwardRef as ReactComponent };